module.exports = function () {
  this.id = "";
  this.icalId = "";
  /**
   * 件名
   */
  this.subject = "";
  this.rooms = [];
  /**
   * 終日予約可どうか
   */
  this.isAllDay = false;
  /**
   * 必須参加者
   */
  this.requiredUsers = [];
  /**
   * 任意参加者
   */
  this.optionalUsers = [];
  this.organizer = {};
  this.startDate = {};
  this.endDate = {};
  /**
   * チェックインしているユーザーのリスト
   */
  this.checkins = [];
  /**
   * チェックアウトしているユーザーのリスト
   */
  this.checkouts = [];
};
